import React, { Component, ErrorInfo, ReactNode } from 'react';
import { useError } from '../../context/ErrorContext';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundaryClass extends Component<Props & { setError: (error: Error) => void }, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const formattedError = {
      ...error,
      isInitializationError: true, 
    };
    this.props.setError(formattedError);
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    return this.props.children;
  }
}

export const ErrorBoundary: React.FC<Props> = ({ children }) => {
  const { setError } = useError();
  
  return (
    <ErrorBoundaryClass setError={setError}>
      {children}
    </ErrorBoundaryClass>
  );
}; 